export const language = {
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',
    'Operation': '操作',
    'Order status': '订单状态',
    'All': '全部',
    'To be confirmed': '待确认',
    'Ready for shipment': '待发货',
    'Shipped': '已发货',
    'Completed': '已完成',
    'Cancelled': '已取消',
    'Order No.': '订单编号',
    'Creation Time': '创建日期',
    'Product Name': '商品名称',
    'Order Source': '订单来源',
    'Order Source No.': '订单来源编号',
    'Consignee': '收货人姓名',
    'Container No.': '柜号',
    'Domestic Order': '国内订单',
    'International Order': '国际订单',
    'Reset': '重置',
    'Query': '查询',
    'Expected arrival date': '期望到货日期',
    'Order Detail': '查看订单',
    'One more order': '再下一单',
    'Total_': '共  ',
    '_Products': '  种商品',
    'Unit Price': '单价',
    'Without Tax': '未税',
    'With Tax': '含税',
    'Subtotal': '小计',
    'Total': '商品总计',
    'Fee': '费用',
    'Total Amount': '订单总金额',
    'Payment method': '支付方式',
    'Offline payment': '线下支付',
    'Order Information': '订单信息',
    'Settlement calculation method': '订单结算方式',
    'Calculate the amount payable using the original subtotal of the goods': '订单原金额计算应付',
    'Calculate the amount payable according to the actual quantity received': '按实际收货数量计算应付',
    'Delivery Information': '收货信息',
    'Contact Person': '联系人',
    'Contact Number': '联系电话',
    'Delivery address': '收货地址',
    'Receiving warehouse': '收货仓库',
    'Ships From': '发货国家',
    'Spec': '规格',
    'VAT': '增值税',
    'Import Tariffs': '进口关税',
    'Remark': '备注',
    'Supplier Information': '卖家信息',
    'Supplier': '供应商',
    'Land line telephone': '座机',
    'Mobile phone': '手机号',
    'Email': '邮箱',
    'ERP Information': 'ERP信息',
    'Synchronize data status': 'ERP同步状态',
    'Push to ERP': '推送ERP',
    'ERP Order No.': 'ERP订单编号',
    'Cancel ERP order': '取消ERP订单',
    'List of Products': '商品列表',
    'Product information': '商品信息',
    'Price (without tax)': '价格(未税)',
    'Price (with tax)': '价格(含税)',
    'Qty': '订单数量',
    'Qty(shipped)': '发货数量',
    'Qty(received)': '收货数量',
    'Subtotal(original)': '订单小计',
    'Subtotal(shipped)': '实发小计',
    'Subtotal(received)': '收货小计',
    'Comprehensive Price': '商品综合单价',
    'Total Amount Payable': '订单应付总金额',
    'Detail': '明细',
    'Comprehensive price calculation': '商品综合价格汇算',
    'Amount': '订单金额',
    'Estimated amount payable': '预计应付金额',
    'Amount payable': '应付金额',
    'Product code': '商品编码',
    'Picture': '图片',
    'Average Fee': '平均费用',
    'Comp Subtotal': '商品综合小计',
    'Comp Unit price': '商品综合单价',
    'Confirm Receipt': '确认收货',
    'Cancel Order': '取消订单',
    'Please fill in the received quantity after confirming the order amount': '请在确认订单金额无误后填写收货数量',
    'After confirming, the unit price and the amount payable  will be calculated according to the actual quantity': '确认收货后，将按实际收货数量计算商品单价、订单应付总金额等，且不可变更',
    'Order push to ERP after completed': '采购单完成同步ERP',
    'Automatic': '自动同步',
    'Manual': '手动同步',
    'Date of bookkeeping': '记账日期',
    'No data': ' 暂无数据',
    'Confirm the cancellation?': '确认取消订单?',
    'View purchase order': '查看采购单',
    'Order Creation Time': '订单创建时间',
    'Expected arrival time': '期望到货时间',
    'Number': '数量',
    'The estimated amount is based on the delivered Qty, and the final amount will be calculated based on the actual received qty': '预计应付金额为按发货数量计算的金额，确认收货后将按实际收货数量计算最终的应付金额',
    'The average cost of goods is calculated by the unit price of goods + VAT + average fee': '商品平均成本，由商品单价+增值税费+平均费用计算得出',
    'The comp subtotal of product is calculated by the subtotal+tariff+value-added taxes and fee': '商品综合小计，由商品小计+进口关税税费+增值税费+商品产生费用计算得出',
    'Average cost of goods, calculated from the total subtotal/quantity of goods': '商品平均成本，由商品综合小计费用/商品数量计算得出',
    'Estimated total amount payable': '预计应付总金额',
    'Item': '费用项',
    'Amount of fees': '费用金额',
    'Notes': '费用备注',
    'Fee Detail': '费用明细',
    'The amount payable has been calculated based on the confirmed receipt qty': '已按确认收货数量计算以下应付金额'
  },
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',
    'Operation': 'Operation',
    'Search': 'Search',
    'Order status': 'Order status',
    'All': 'All',
    'To be confirmed': 'To be confirmed',
    'Ready for shipment': 'Ready for shipment',
    'Shipped': 'Shipped',
    'Completed': 'Completed',
    'Cancelled': 'Cancelled',
    'Order No.': 'Order No.',
    'Creation Time': 'Creation Time',
    'Product Name': 'Product Name',
    'Order Source': 'Order Source',
    'Order Source No.': 'Order Source No.',
    'Supplier': 'Supplier',
    'Consignee': 'Consignee',
    'Container No.': 'Container No.',
    'Domestic Order': 'Domestic Order',
    'International Order': 'International Order',
    'Reset': 'Reset',
    'Query': 'Query',
    'Expected arrival date': 'Expected arrival date',
    'Order Detail': 'Order Detail',
    'One more order': 'One more order',
    'Total_': 'Total  ',
    '_Products': '  Products',
    'Unit Price': 'Unit Price',
    'Without Tax': 'Without Tax',
    'With Tax': 'With Tax',
    'Subtotal': 'Subtotal',
    'Total': 'Total',
    'Fee': 'Fee',
    'Total Amount': 'Total Amount',
    'Payment method': 'Payment method',
    'Offline payment': 'Offline payment',
    'Order Information': 'Order Information',
    'Settlement calculation method': 'Settlement calculation method',
    'Calculate the amount payable using the original subtotal of the goods': 'Calculate the amount payable using the original subtotal of the goods',
    'Calculate the amount payable according to the actual quantity received': 'Calculate the amount payable according to the actual quantity received',
    'Delivery Information': 'Delivery Information',
    'Contact Person': 'Contact Person',
    'Contact Number': 'Contact Number',
    'Delivery address': 'Delivery address',
    'Receiving warehouse': 'Receiving warehouse',
    'Ships From': 'Ships From',
    'Spec': 'Spec',
    'VAT': 'VAT',
    'Import Tariffs': 'Import Tariffs',
    'Remark': 'Remark',
    'Supplier Information': 'Supplier Information',
    'Land line telephone': 'Land line telephone',
    'Mobile phone': 'Mobile phone',
    'Email': 'Email',
    'ERP Information': 'ERP Information',
    'Synchronize data status': 'Synchronize data status',
    'Push to ERP': 'Push to ERP',
    'ERP Order No.': 'ERP Order No.',
    'Cancel ERP order': 'Cancel ERP order',
    'List of Products': 'List of Products',
    'Product information': 'Product information',
    'Price (without tax)': 'Price (without tax)',
    'Price (with tax)': 'Price (with tax)',
    'Qty': 'Qty',
    'Qty(shipped)': 'Qty(shipped)',
    'Qty(received)': 'Qty(received)',
    'Subtotal(original)': 'Subtotal(original)',
    'Subtotal(shipped)': 'Subtotal(shipped)',
    'Subtotal(received)': 'Subtotal(received)',
    'Comprehensive Price': 'Comprehensive Price',
    'Total Amount Payable': 'Total Amount Payable',
    'Detail': 'Detail',
    'Comprehensive price calculation': 'Comprehensive price calculation',
    'Amount': 'Amount',
    'Estimated amount payable': 'Estimated amount payable',
    'Amount payable': 'Amount payable',
    'Product code': 'Product code',
    'Picture': 'Picture',
    'Average Fee': 'Average Fee',
    'Comp Subtotal': 'Comp Subtotal',
    'Comp Unit price': 'Comp Unit price',
    'Confirm Receipt': 'Confirm Receipt',
    'Cancel Order': 'Cancel Order',
    'Please fill in the received quantity after confirming the order amount': 'Please fill in the received quantity after confirming the order amount',
    'After confirming, the unit price and the amount payable  will be calculated according to the actual quantity': 'After confirming, the unit price and the amount payable  will be calculated according to the actual quantity',
    'Order push to ERP after completed': 'Order push to ERP after completed',
    'Automatic': 'Automatic',
    'Manual': 'Manual',
    'Date of bookkeeping': 'Date of bookkeeping',
    'No data': 'No data',
    'Confirm the cancellation?': 'Confirm the cancellation?',
    'View purchase order': 'View purchase order',
    'Order Creation Time': 'Order Creation Time',
    'Expected arrival time': 'Expected arrival time',
    'Number': 'Number',
    'The estimated amount is based on the delivered Qty, and the final amount will be calculated based on the actual received qty': 'The estimated amount is based on the delivered Qty, and the final amount will be calculated based on the actual received qty',
    'The average cost of goods is calculated by the unit price of goods + VAT + average fee': 'The average cost of goods is calculated by the unit price of goods + VAT + average fee',
    'The comp subtotal of product is calculated by the subtotal+tariff+value-added taxes and fee': 'The comp subtotal of product is calculated by the subtotal+tariff+value-added taxes and fee',
    'Average cost of goods, calculated from the total subtotal/quantity of goods': 'Average cost of goods, calculated from the total subtotal/quantity of goods',
    'Estimated total amount payable': 'Estimated total amount payable',
    'Item': 'Item',
    'Amount of fees': 'Amount of fees',
    'Notes': 'Notes',
    'Fee Detail': 'Fee Detail',
    'The amount payable has been calculated based on the confirmed receipt qty': 'The amount payable has been calculated based on the confirmed receipt qty',
  }
};